<template>
  <div class="switch-container">
    <!-- Bouton Soleil = Thème Modern -->
    <button
      @click="handleThemeChange('classic')"
      class="theme-switch-button"
      :class="{ active: currentTheme === 'modern' }"
    >
      <IconRenderer
        :name="currentTheme === 'modern' ? 'sunny' : 'sunny-outline'"
        type="ionic"
        class="icon theme-icon"
        :clickable="true"
      />
    </button>

    <!-- Bouton Nuage = Thème Classic -->
    <button
      @click="handleThemeChange('modern')"
      class="theme-switch-button"
      :class="{ active: currentTheme === 'classic' }"
    >
      <IconRenderer
        :name="currentTheme === 'classic' ? 'cloudy-night' : 'cloudy-night-outline'"
        type="ionic"
        class="icon theme-icon"
        :clickable="true"
      />
    </button>

    <!-- Bouton Lune = Thème Dark -->
    <button
      @click="handleThemeChange('dark')"
      class="theme-switch-button"
      :class="{ active: currentTheme === 'dark' }"
    >
      <IconRenderer
        :name="currentTheme === 'dark' ? 'moon' : 'moon-outline'"
        type="ionic"
        class="icon theme-icon"
        :clickable="true"
      />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { logger } from '@/common/services/config';
import { computed } from 'vue';
import { useTheming, type ThemeMode } from '@/common/composables/useTheming';
import IconRenderer from '../icon/IconRenderer.vue';

// Emits
const emit = defineEmits<{
  themeToggled: [];
}>();

const { themeMode, setThemeMode } = useTheming();

// Computed pour obtenir le thème actuel
const currentTheme = computed<ThemeMode>(() => {
  return themeMode.value;
});
logger.log('Current theme mode:', currentTheme.value); // Debug log
// Gestion du changement de thème
const handleThemeChange = (theme: ThemeMode) => {
  setThemeMode(theme);
  emit('themeToggled');
};
</script>

<style scoped>
.switch-container {
  display: flex;
  justify-content: space-evenly;
  gap: 8px;
}

.theme-switch-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
}

.theme-switch-button:hover {
  transform: scale(1.05);
}

.theme-switch-button.active {
  transform: scale(1.1);
}

.theme-switch-button.active .theme-icon {
  color: var(--ion-color-primary);
}

.theme-icon {
  font-size: 20px;
  color: var(--ion-text-color-secondary);
  transition: color 0.2s ease;
}
</style>
